import React from 'react'
import { datalayerHandler } from '../../../../utils/datalayer'
import { Link } from '../../../../utils/link'
import { linkGridCentraBlockClasses } from '../../../../utils/style'
import { convertReactNodeToString, getClassName, htmlDecode } from '../../../../utils/utils'
import { useInView } from '../../../hooks/useInView'
import { LinkGridBlock } from '../blocksState'
import { LinkGridBlockStyle, LinkGridItemLayout } from './linkGridBlockLayout'

export type LinkGridCentraBlockStyle = Partial<{
  gridItem1ClassName: string
  gridItem2ClassName: string
  gridItem3ClassName: string
}> &
  LinkGridBlockStyle

const getGridItemClassName = (i: number) =>
  i == 0 ? 'gridItem1ClassName' : i == 1 ? 'gridItem2ClassName' : 'gridItem3ClassName'

export const LinkGridCentraBlockLayout = (props: LinkGridBlock) => {
  const { inview, index, items, intro, primaryAction, title, withImages } = props
  const classes = linkGridCentraBlockClasses(withImages)

  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("LinkGridCentraBlockLayout inView:", inview),
    !inview?.triggerOnce
  )

  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(classes, 'innerClassName', 'py-5')}>
        {(title || intro) && (
          <header className={getClassName(classes, 'headerClassName', 'text-center')}>
            {title && (
              <h2 className={getClassName(classes, 'titleClassName', 'mb-3')}>
                <span id={`${index}`} aria-hidden="true" className="block__anchor" />
                {title}
              </h2>
            )}
            {intro && <p className={getClassName(classes, 'introClassName', '')}>{intro}</p>}
          </header>
        )}

        {items && items.length == 3 && (
          <div className={getClassName(classes, 'contentClassName', '')}>
            <ul className={getClassName(classes, 'listClassName', 'row list-unstyled mb-0')}>
              {items.map((item, i) => (
                <li
                  className={getClassName(classes, getGridItemClassName(i), 'col-md-6 col-lg-4 py-3')}
                  key={`grid-centra-${index}-${i}`}
                >
                  <article className={getClassName(classes, 'gridArticleClassName', '')}>
                    {item.link && item.link.title && item.link.url ? (
                      <Link
                        url={item.link.url}
                        title={item.link.title}
                        className={getClassName(
                          classes,
                          'gridWithLinkClassName',
                          'd-flex flex-column-reverse text-secondary'
                        )}
                      >
                        <LinkGridItemLayout
                          {...item}
                          imageOptions={props.withImages ? props.imageOptions : undefined}
                          classes={classes}
                        />
                      </Link>
                    ) : (
                      <div className={getClassName(classes, 'gridWithoutLinkClassName', 'd-flex flex-column-reverse')}>
                        <LinkGridItemLayout
                          {...item}
                          imageOptions={props.withImages ? props.imageOptions : undefined}
                          classes={classes}
                        />
                      </div>
                    )}
                  </article>
                </li>
              ))}
            </ul>
          </div>
        )}

        {primaryAction && primaryAction.title && (
          <footer className={getClassName(classes, 'footerClassName', 'text-center')}>
            <div className={getClassName(classes, 'clickableWrapperClassName', 'd-inline-block')}>
              <Link
                url={primaryAction.url}
                title={primaryAction.title}
                className={getClassName(classes, 'clickableClassName', 'btn btn-dark d-inline-flex')}
                additionalOnClick={() =>
                  datalayerHandler('link-grid', undefined, undefined, {
                    kind: 'link',
                    title: convertReactNodeToString(title),
                    link: primaryAction.url,
                    label: primaryAction.title,
                  })
                }
              >
                <span className={getClassName(classes, 'clickableLabelClassName', '')}>
                  {htmlDecode(primaryAction.title)}
                </span>
                {primaryAction.SVGIcon && (
                  <svg
                    className={getClassName(classes, 'clickableIconClassName', 'ml-3')}
                    aria-hidden="true"
                    width={primaryAction.SVGIcon.width ? primaryAction.SVGIcon.width : '24px'}
                    height={primaryAction.SVGIcon.height ? primaryAction.SVGIcon.height : '24px'}
                  >
                    <use xlinkHref={getClassName(classes, 'iconId', '#icon--chevron-right-large')} />
                  </svg>
                )}
              </Link>
            </div>
          </footer>
        )}
      </div>
    </section>
  )
}
